/**
 * @desc 保存帮助文档
 */
import { HelpDocEntity, HelpDocForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateHelpDocParameter = HelpDocForm

const method = 'POST'
const url = '/content/operation/help/doc'

export const createHelpDocApi = (
  data?: CreateHelpDocParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<HelpDocEntity>({
    method,
    url,
    data,
    ...config
  })
}

createHelpDocApi.method = method
createHelpDocApi.url = url
